export default value => `${value[0].toUpperCase()}${value.slice(1)}`
